import { configureStore } from '@reduxjs/toolkit'
// import { setupListeners } from '@reduxjs/toolkit/query'
import { campaignsSlice } from 'features/campaigns'
import { notificationSlice } from 'features/notifications'
import { rtkQueryErrorLogger } from 'shared/errors'

import { apiRTK } from '../api/api-rtk'
import { automationApi } from '../api/automationApi'
import { activitySlice } from './reducers/activity'
import { appSlice } from './reducers/app'
import campaign from './reducers/campaign'
import { campaignCreateSlice } from './reducers/campaignCreate'
import contacts from './reducers/contacts'
import { leftSideSlice } from './reducers/leftSideMenu'
import campaignsTeams from './reducers/teams'

const store = configureStore({
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware({
			// ! Store data like this in not Redux way. Better to refactor
			immutableCheck: false,
			serializableCheck: false
			// serializableCheck: {
			//   ignoredActions: [appSlice.actions.createConnector.type],
			//   ignoredPaths: ["app.connector"],
			// },
		}).concat([
			automationApi.middleware,
			apiRTK.middleware,
			rtkQueryErrorLogger
		]),

	reducer: {
		[activitySlice.reducerPath]: activitySlice.reducer,
		[apiRTK.reducerPath]: apiRTK.reducer,
		[appSlice.name]: appSlice.reducer,
		[automationApi.reducerPath]: automationApi.reducer,
		campaign,
		[campaignCreateSlice.name]: campaignCreateSlice.reducer,
		[campaignsSlice.name]: campaignsSlice.reducer,
		campaignsTeams,
		contacts,
		[leftSideSlice.name]: leftSideSlice.reducer,
		[notificationSlice.name]: notificationSlice.reducer
	}
})

type AppDispatch = typeof store.dispatch
type RootState = ReturnType<typeof store.getState>

// setupListeners(store.dispatch)

export { store }
export type { AppDispatch, RootState }

export default store
